import { render, staticRenderFns } from "./paymentPoolList.vue?vue&type=template&id=21b38c10&scoped=true"
import script from "./paymentPoolList.vue?vue&type=script&lang=js"
export * from "./paymentPoolList.vue?vue&type=script&lang=js"
import style0 from "./paymentPoolList.vue?vue&type=style&index=0&id=21b38c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b38c10",
  null
  
)

export default component.exports